import React from "react";
import { Link } from "react-router-dom";
import { APPS } from "@/data/apps";
import Reveal from "@/components/Reveal";
import CountUp from "@/components/CountUp";

export default function AppsIndexPage() {
  const liveCount = APPS.filter((a) => a.status === "live").length;

  return (
    <section className="services page-pad">
      <div className="wrap">
        <Reveal className="section__head">
          <p className="eyebrow">Apps</p>
          <h1 className="page-title">Shopify apps by IT-Patrol</h1>
          <p>Live products on the Shopify App Store — inventory holds, cart urgency, and AI-assisted conversion.</p>
        </Reveal>

        <Reveal className="page-metrics" delay={90}>
          <div className="page-metric">
            <strong>
              <CountUp to={liveCount} />
            </strong>
            <span>Live on App Store</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={APPS.length} />
            </strong>
            <span>Product surfaces</span>
          </div>
          <div className="page-metric">
            <strong>
              <CountUp to={new Set(APPS.map((a) => a.practice)).size} />
            </strong>
            <span>Practice lanes covered</span>
          </div>
        </Reveal>

        <div className="service-grid">
          {APPS.map((app, index) => (
            <Reveal as="article" className="service" key={app.slug} delay={140 + index * 120}>
              <div className="service__top">
                <h2 style={{ fontSize: "clamp(1.4rem, 2.2vw, 1.85rem)" }}>{app.name}</h2>
                <span className="service__idx">{String(index + 1).padStart(2, "0")}</span>
              </div>
              <div className="service__pain">
                <strong>{app.practice}</strong>
                {app.tagline}
              </div>
              <div className="service__pain">
                <strong>Status</strong>
                {app.status === "live" ? "Live on Shopify App Store" : app.status}
              </div>
              <div className="service__tags">
                <span className="tag">{app.practice}</span>
                <span className="tag">{app.status}</span>
                <Link className="tag" to={`/apps/${app.slug}`} style={{ textDecoration: "underline" }}>
                  View details →
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
